import { render } from "./ContextMenu.vue?vue&type=template&id=e3b7af6c"
import script from "./ContextMenu.vue?vue&type=script&lang=js"
export * from "./ContextMenu.vue?vue&type=script&lang=js"

import "./ContextMenu.vue?vue&type=style&index=0&id=e3b7af6c&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__